// extracted by mini-css-extract-plugin
module.exports = {"description":"index_description__XK7Qi","title":"index_title__3D58M","heading":"index_heading__eidS5","content":"index_content__2fdkz"};